import axios from "axios";

export function getAllUserAddress() {
  return axios.get(process.env.VUE_APP_API_URL + "Sso/GetAllUserAddress");
}

export function postUserAddress(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Sso/AddUserAddress", data);
}

export function updateUserAddress(data) {
  return axios.put(process.env.VUE_APP_API_URL + "Sso/UpdateUserAddress", data);
}

export function deleteUserAdress(userAddressId) {
  const config = {
    params: {
      userAddressId: userAddressId,
    },
  };
  return axios.delete(process.env.VUE_APP_API_URL + "Sso/DeleteUserAddress", config);
}
